import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section id="cta" className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20waves%20in%20amber%20and%20cream%20tones%2C%20modern%20digital%20creativity%20theme%2C%20ethereal%20glowing%20particles%2C%20minimalist%20SaaS%20atmosphere%2C%20inspirational%20and%20inviting%20mood%2C%20smooth%20curves%2C%20professional%20aesthetic&width=1600&height=700&seq=cta-bg-section&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-5 font-heading">
          准备好免费在线成网站了吗？
        </h2>
        <p className="text-base text-background-50/80 mb-9 max-w-xl mx-auto leading-relaxed">
          零成本、零门槛、几分钟上线。加入50万+用户，开启你的网站之旅。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-400 transition-all duration-300 whitespace-nowrap"
          >
            立即免费建站
            <i className="ri-rocket-line ml-2"></i>
          </a>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}